module.exports = __webpack_public_path__ + "img/like_highlight.a5553bc.png";